import {CustomImage} from '@buncha/components/core/Image';
import {Box, HBox} from '../../../components/core/view';
import If from '@buncha/components/conditional/If';
import ItemQuantityPill from '../../../components/composites/ItemQuantityPill/ItemQuantityPill';
import React from 'react';
import {StyleSheet} from 'react-native';
import {getDefaultImageUrl} from '../../../utils/common';

interface ImageWithQuantityPillProps {
  imageLink: string;
  quantity?: number;
  isNSCItem?: boolean;
  totalWeight?: number;
  unit?: string;
}

function ImageWithQuantityPill(props: ImageWithQuantityPillProps) {
  const {imageLink} = props;
  return (
    <Box>
      <CustomImage
        source={imageLink || getDefaultImageUrl()}
        resizeMode="cover"
        style={styles.itemImage}
      />
      <If condition={props?.quantity}>
        <HBox style={styles.quantityArea}>
          <ItemQuantityPill
            quantity={props?.quantity ?? 0}
            isNSCItem={props?.isNSCItem}
            totalWeight={props?.totalWeight}
            unit={props?.unit}
          />
        </HBox>
      </If>
    </Box>
  );
}

export default React.memo(ImageWithQuantityPill);

const styles = StyleSheet.create({
  itemImage: {
    height: 75,
    width: 75,
    overflow: 'hidden',
  },
  quantityArea: {
    marginTop: 25,
    justifyContent: 'center',
  },
});
